import api from "@/router/api"

export default {
    getAllOrderMaintenanceTypeId({commit}, payload){

        return new Promise((resolve, reject) => {
            api.auxiliariesOrderMaintenanceTypeVhe.list(payload)
            .then(response => {
                resolve(response.data.data)

                commit('SET_ORDERMAINTENANCES', response.data.data)
            })
            .catch(error => {
                reject({
                    message: 'Ocurrió un problema al obtener el proveedor',
                })
            })
        })
    },
}
